import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

export const MapContainer = styled(Box)<{ height?: number }>(({ theme, height = 450 }) => ({
  position: "relative",
  width: "100%",
  height: `${height}px`,
  borderRadius: theme.spacing(1),
  overflow: "hidden",
  border: `1px solid ${theme.palette.divider}`,
  backgroundColor: theme.palette.grey[100],
  "& .leaflet-container": {
    width: "100%",
    height: "100%",
    borderRadius: theme.spacing(1),
  },
}));

export const MapElement = styled("div")({
  width: "100%",
  height: "100%",
});

export const CoordinatesInfo = styled(Box)(({ theme }) => ({
  position: "absolute",
  bottom: theme.spacing(2),
  left: theme.spacing(2),
  backgroundColor: "rgba(255, 255, 255, 0.95)",
  padding: theme.spacing(1.5, 2),
  borderRadius: theme.spacing(1),
  zIndex: 1000,
  boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
}));

export const MapModeControls = styled(Box)(({ theme }) => ({
  position: "absolute",
  top: theme.spacing(2),
  right: theme.spacing(2),
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-end",
  gap: theme.spacing(1),
  zIndex: 1000,
}));

export const LoadingBox = styled(Box)({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  zIndex: 1000,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: "16px",
});
